<div class="title" mat-dialog-title>Add an API Key</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your account manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>StackAdapt API Key</mat-label>
                <input matInput placeholder="Enter StackAdapt API Key" formControlName="apiKey" data-cy="stackadapt-apikey-input">
                <mat-error
                    *ngIf="connectionForm.get('apiKey').errors && (connectionForm.get('apiKey').touched || 
                    connectionForm.get('apiKey').dirty)">
                    Invalid Api Key</mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="stackadapt-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>